import { render, staticRenderFns } from "./MyGroup.vue?vue&type=template&id=3f33803b&scoped=true&"
import script from "./myGroup.ts?vue&type=script&lang=ts&"
export * from "./myGroup.ts?vue&type=script&lang=ts&"
import style0 from "./MyGroup.vue?vue&type=style&index=0&id=3f33803b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f33803b",
  null
  
)

export default component.exports